module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintNoc"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printNoc()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printNoc"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.myhost !== 'fincare.13squad.com') ? _c('table', {
    staticClass: "table printing"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), (_vm.getCompanyRecord.cin) ? _c('span', [_vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ",")]) : _vm._e(), _vm._v(" "), (_vm.getCompanyRecord.url) ? _c('span', [_vm._v("Website - " + _vm._s(_vm.getCompanyRecord.url) + ",")]) : _vm._e(), _vm._v(" Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br')])])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "4px solid gray"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("Date: " + _vm._s(_vm._f("myDate")(_vm.curDate)))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Loan Application No :")]), _vm._v(" " + _vm._s(_vm.seeRecord.applicationNo))]), _vm._v(" "), (_vm.seeRecord.disbursement) ? _c('p', [_c('strong', [_vm._v("Loan Amount :")]), _vm._v(" " + _vm._s(_vm.getPlanAmt(_vm.seeRecord.disbursement)))]) : _vm._e(), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Customer Name : ")]), (_vm.seeRecord.member) ? _c('strong', [_vm._v(_vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mobile : ")]), _vm._v(" "), (_vm.seeRecord.member) ? _c('strong', [_vm._v(_vm._s(_vm.seeRecord.member.mobile))]) : _vm._e()]), _vm._v(" "), (_vm.seeRecord.disbursement) ? _c('p', [_c('strong', [_vm._v("Loan Disbursement Date :")]), _vm._v(" " + _vm._s(_vm.seeRecord.disbursement.disbursementDate))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Subject - Non Objection Certificate (NOC)")]), _vm._v(" "), _c('strong', [_vm._v("Dear Customer")]), _vm._v(" "), _c('p', [_vm._v("With reference to above mentioned Subject we hereby issue the “LOAN CLOSURE LETTER” of Your Loan Account No "), _c('strong', [_vm._v(_vm._s(_vm.seeRecord.applicationNo))]), _vm._v(" With The Name "), (_vm.seeRecord.member) ? _c('strong', [_vm._v(_vm._s(_vm.seeRecord.member.name))]) : _vm._e(), _vm._v(" has fulfilled your entire obligation and paid all the outstanding dues under the said Loan Agreement.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _c('br'), _vm._v(" "), _c('p', [_vm._v("Chief Operating Manager")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Disclaimer:")]), _vm._v(" "), _c('p', [_vm._v("The NOC letter Will not be applicable in case this loan gets closed due to technical error or if the same is unpaid")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("This is system generated letter and does not require any signature.")])]), _c('br')]) : _vm._e()])])])]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("(Incorporated under the Companies Act, 2013) Registered by Ministry of Corporate Affairs, Govt. of India")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This is for your information and needful.\n                        "), _c('br'), _vm._v("Your faithfully\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e683783!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/Noc.vue
// module id = 838
// module chunks = 0